module.exports = __webpack_public_path__ + "img/motyl_1_1.82682f95.png";